import { Controller } from '@hotwired/stimulus'

// Поле даты (input type="date") в форме матча, account/matches/new.slim:
// - пока дата не выбрана, контейнер получает .is-empty, и маска «дд.мм.гггг»
//   серая, как плейсхолдер (у type="date" нет :placeholder-shown);
// - клик по любому месту поля открывает календарь, а не только по иконке.
export default class DateFieldController extends Controller {
  static targets = ['input']

  connect() {
    this.sync()
  }

  sync() {
    this.element.classList.toggle('is-empty', !this.inputTarget.value)
  }

  open() {
    try {
      this.inputTarget.showPicker?.()
    } catch {
      // showPicker бросает вне жеста пользователя и в старых браузерах —
      // тогда остаётся обычное поведение поля.
    }
  }
}
